import { render, staticRenderFns } from "./BamboraForm.vue?vue&type=template&id=1a90d54a&"
import script from "./BamboraForm.vue?vue&type=script&lang=js&"
export * from "./BamboraForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports